module.exports = __webpack_public_path__ + "img/head_logo.674f2b50.png";